const KPI_KEY = "stoq-ad-console:kpi-metrics:v1";

export function loadKpiOrder<T extends string>(fallback: T[]): T[] {
  try {
    const raw = window.localStorage.getItem(KPI_KEY);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((v) => typeof v === "string")) {
      return parsed as T[];
    }
    return fallback;
  } catch {
    return fallback;
  }
}

export function saveKpiOrder(order: readonly string[]): void {
  try {
    window.localStorage.setItem(KPI_KEY, JSON.stringify(order));
  } catch {
    // localStorageが使えない環境（プライベートモード等）では黙って諦める。UI動作は継続。
  }
}

const MK_CALENDAR_OPEN_KEY = "stoq-ad-console:mk:calendarOpen:v1";

/** 施策画面のカレンダー（Timeline）を開いているかどうか。既定 false（閉じる）。 */
export function loadMkCalendarOpen(): boolean {
  try {
    return window.localStorage.getItem(MK_CALENDAR_OPEN_KEY) === "1";
  } catch {
    return false;
  }
}

export function saveMkCalendarOpen(open: boolean): void {
  try {
    window.localStorage.setItem(MK_CALENDAR_OPEN_KEY, open ? "1" : "0");
  } catch {
    // localStorageが使えない環境（プライベートモード等）では黙って諦める。UI動作は継続。
  }
}
